export const themecolors = {
    dark_background_1: '#121212',
    dark_background_2: '#161616',
    dark_background_3 : '#222222',
    dark_background_4: '#252525',
    dark_background_5: '#272727',
    dark_background_6: '#2c2c2c',
    dark_background_7: '#2e2e2e',
    dark_background_8: '#333333',
    dark_background_9: '#363636',
    dark_background_10: '#383838',
    dark_low_impact_text: 'rgba(255,255,255,.38)',
    dark_medium_impact_text: 'rgba(255,255,255,.6)',
    dark_high_impact_text: 'rgba(255,255,255,.87)',
    light_medium_impact_text: '#536471',
    light_high_impact_text: '#2A2F36',
    light_low_impact_text: 'rgba(101,97,117)',
    light_zero_impact_text: '#7f7c8d',
    pure_white: '#fff',
    pure_black: '#000',
    light_input: '#edeff0d9',
    light_border: '#dfdfdf',
    lighter_border: '#e4e4e4',
    lightest_border: '#eeeeee',
};